<template>
  <div class="operationLog">
    <div class="titleWrap">
      <div class="setTitle">操作日志</div>
      <div class="clearfix"></div>
    </div>
    <el-main class="tableWrap">
      <el-input class="input" v-model.trim="operatorName" size="small" placeholder="操作人"></el-input>
      <el-input class="input" v-model.trim="ip" size="small" placeholder="用户IP"></el-input>
      <el-date-picker class="time" v-model="operationTime" size="small" type="daterange" :editable="false" range-separator="至" start-placeholder="操作日期" end-placeholder="操作日期"></el-date-picker>
      <el-button class="searchBtn" type="primary" size="small" @click="search"><i class="el-icon-search"></i></el-button>
      <div class="clearfix"></div>
      <el-table :data="operationAttr" class="list">
        <el-table-column type="index" label="序号" width="80" :index="indexMethod" :align="align"></el-table-column>
        <el-table-column prop="admin" label="操作人" min-width="180" :align="align"></el-table-column>
        <el-table-column prop="operation" label="操作内容" min-width="180" :align="align">
          <template slot-scope="scope">
            {{ scope.row.moduleName }} - {{ scope.row.operation }}
          </template>
        </el-table-column>
        <el-table-column prop="ip" label="用户IP" min-width="180" :align="align">
          <template slot-scope="scope">
            {{ notData(scope.row.ip) }}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="操作时间" min-width="180" :align="align">
          <template slot-scope="scope">
            {{ operateTime(scope.row.createTime) }}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="total, sizes, prev, pager, next, jumper" :current-page.sync="operationCurr" :page-sizes="[10, 20, 50]" :page-size="operationSize" :total="operationTotal" @current-change="operationCurrChange" @size-change="operationSizeChange"></el-pagination>
    </el-main>
  </div>
</template>

<script>
export default {
  name: 'OperationLog',
  data () {
    return {
      align: this.$align, // 表格对齐方式
      operatorName: '', // 操作人查询输入框
      ip: '', // 用户IP查询输入框
      operationTime: '', // 操作日期查询输入框
      operationAttr: [], // 操作日志列表
      operationTotal: 0, // 操作日志总数
      operationSize: 10, // 操作日志每页条数
      operationCurr: 1 // 操作日志当前页数
    }
  },
  mounted () {
    // 获取操作日志列表
    this.getOperationList(this.operationCurr, this.operationSize)
  },
  methods: {
    getOperationList (page, size) {
      let operateTimeStart = ''
      let operateTimeEnd = ''
      if (this.operationTime !== '' && this.operationTime !== null) {
        operateTimeStart = this.$date1(this.operationTime[0].toString()) + ' 00:00:00'
        operateTimeEnd = this.$date1(this.operationTime[1].toString()) + ' 23:59:59'
      }
      this.$http.get(this.$api.log_list, {
        params: {
          pageNum: page,
          pageSize: size,
          admin: this.operatorName,
          ip: this.ip,
          startTime: operateTimeStart,
          endTime: operateTimeEnd
        }
      }).then((res) => {
        let data = res.data

        if (data.success) {
          this.operationAttr = data.data.data
          this.operationTotal = data.data.total
          this.operationSize = size
          this.operationCurr = page
        } else {
          this.$message({
            type: 'error',
            message: data.msg,
            duration: 1000
          })
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    search () {
      this.getOperationList(1, this.operationSize)
    },
    operationCurrChange (curr) {
      this.getOperationList(curr, this.operationSize)
    },
    operationSizeChange (size) {
      this.getOperationList(this.operationCurr, size)
    },
    notData (str) {
      return this.$null(str)
    },
    operateTime (time) {
      if (time === '' || time === null) {
        return '-'
      } else {
        return time.substr(0, 4) + '-' + time.substr(5, 2) + '-' + time.substr(8, 2) + ' ' + time.substr(11, 2) + ':' + time.substr(14, 2) + ':' + time.substr(17, 2)
      }
    },
    indexMethod (index) {
      // index从0开始
      return index + 1 + (this.operationCurr - 1) * this.operationSize
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.operationLog
  box-sizing border-box
  padding 80px 20px 60px
  width 100%
  height 100%
  background-color #F5F7FA
  .titleWrap
    width 100%
    height 32px
    .setTitle
      float left
      height 32px
      line-height 32px
      font-weight bold
      font-size 18px
      color #333
  .tableWrap
    margin-top 20px
    padding-left 0px
    padding-right 0px
    background-color #fff
    border-radius 4px
    box-shadow 0 3px 5px 0 rgba(0, 0, 0, .05)
    .select
      float left
      margin-left 20px
      width 160px
    .input
      float left
      margin-left 20px
      width 160px
    .time
      float left
      margin-left 20px
    .searchBtn
      float left
      margin-left 20px
      padding 5.5px 6px
      font-size 18px
    .list
      margin-top 20px
      thead
        tr, th
          color #666
          background-color #fafafa
          .cell
              font-weight bold
      tbody
        tr, th
          color #333
      td
        padding 7px 0
      .cell
        line-height 26px
    .el-pagination
      margin-top 20px
      padding 0 20px 0
      text-align right
</style>



// WEBPACK FOOTER //
// src/components/system/operationLog.vue